import widgetHtml from "./widget.html"
import "./widget.css"

import Cookies from "js-cookie"
import { HeaderInjector } from "../HeaderInjector"
import { getRootDomain, toggleClass, waitForElement } from "../helpers"
import { AUTO_HIDE_COOKIE_KEY } from "../consts"

export async function initWidget(ctx: HeaderInjector, appendToEl?: string) {
  if ("Cypress" in globalThis) {
    console.log("Header Injector: Widget is hidden in Cypress environment")
    return
  }

  const wrapper = await waitForElement(appendToEl || "body", 5000)
  if (!wrapper) throw new Error(`Header Injector: ${appendToEl} not found`)
  wrapper.insertAdjacentHTML("afterbegin", widgetHtml)

  const el = (id: string) => document.getElementById(id)

  let editMode = false

  // Elements
  const widget = el("header-injector-widget") as HTMLDivElement
  const text = el("header-injector-text") as HTMLDivElement
  const headerValue = el("header-injector-header-value") as HTMLButtonElement
  const form = el("header-injector-form") as HTMLFormElement
  const input = el("header-injector__input") as HTMLInputElement

  // Buttons
  const editBtn = el("header-injector-edit-btn") as HTMLButtonElement
  const cancelEditBtn = el("header-injector-cancel-btn") as HTMLButtonElement
  const connectBtn = el("header-injector-con-btn") as HTMLButtonElement
  const disconnectBtn = el("header-injector-discon-btn") as HTMLButtonElement
  const shareBtn = el("header-injector-share-btn") as HTMLButtonElement
  const jiraLink = el("header-injector-jira-link") as HTMLAnchorElement
  const autoHideBtn = el("header-injector-autohide-btn") as HTMLButtonElement

  toggleClass(ctx.isWidgetSticky, widget, "header-injector--sticky")

  const updateHtml = () => {
    if (ctx.isDefaultValue && ctx.headerValue) {
      headerValue.textContent = `${ctx.headerValue} (from .env)`
    } else {
      headerValue.textContent = ctx.headerValue || ""
    }
    input.value = ctx.headerValue || ""
    if (ctx.headerValue) {
      jiraLink.href = `https://soenergy.atlassian.net/browse/${ctx.headerValue.toUpperCase()}`
    } else {
      jiraLink.removeAttribute("href")
    }
    text.textContent = ctx.headerValue
      ? "Connected to on-demand backend"
      : "Connected to staging backend"

    toggleClass(
      Cookies.get(AUTO_HIDE_COOKIE_KEY) === "true",
      widget,
      "auto-hide"
    )
    toggleClass(!!ctx.headerValue, widget, "connected")
    toggleClass(ctx.isDefaultValue, widget, "readonly")
    toggleClass(ctx.isDev, widget, "dev")
    toggleClass(editMode, widget, "edit-mode")
  }

  updateHtml()

  // Events
  editBtn.addEventListener("click", (e) => {
    if (ctx.isDefaultValue) return e.preventDefault()
    editMode = true
    updateHtml()
    input.focus()
  })

  cancelEditBtn.addEventListener("click", () => {
    editMode = false
    updateHtml()
  })

  connectBtn.addEventListener("click", () => {
    editMode = true
    updateHtml()
    input.focus()
  })

  disconnectBtn.addEventListener("click", () => {
    ctx.headerValue = ""
    updateHtml()
  })

  shareBtn.addEventListener("click", () => {
    ctx.copyLinkToClipboard()
    const originalText = shareBtn.innerHTML
    shareBtn.textContent = "Copied!"
    setTimeout(() => (shareBtn.innerHTML = originalText), 1500)
  })

  autoHideBtn.addEventListener("click", () => {
    const currValue = Cookies.get(AUTO_HIDE_COOKIE_KEY) === "true"
    Cookies.set(AUTO_HIDE_COOKIE_KEY, Boolean(!currValue).toString(), {
      expires: 365, // days
      domain: getRootDomain(globalThis.location.hostname),
    })
    updateHtml()
  })

  form.addEventListener("submit", (e) => {
    e.preventDefault()
    ctx.headerValue = input.value
    editMode = false
    widget.focus()
    updateHtml()
  })
}
